const MIN_ANALYSIS_FISCAL_YEAR = 2010;
const CURRENT_ANALYSIS_FISCAL_YEAR = 2027;

export const BUILDER_PERIOD_OPTIONS = Array.from(
  { length: CURRENT_ANALYSIS_FISCAL_YEAR - MIN_ANALYSIS_FISCAL_YEAR },
  (_, index) => `FY${String(MIN_ANALYSIS_FISCAL_YEAR + index).slice(-2)}`,
);

export function analysisPeriodEndFiscalYear(
  fullFiscalYear: number,
  includeYtd: boolean,
): number {
  return fullFiscalYear + (includeYtd ? 1 : 0);
}

export function analysisPeriodEndSelection(
  endFiscalYear: number,
  endIsYtd: boolean,
): { fullFiscalYear: number; includeYtd: boolean } {
  return {
    fullFiscalYear: endFiscalYear - (endIsYtd ? 1 : 0),
    includeYtd: endIsYtd,
  };
}
